import React from "react";
import { type } from "../theme/tokens";

/** Compact Stripe trust line for checkout and pricing areas. */
export function StripeTrustLine({ style = {} }) {
  return (
    <p
      style={{
        ...type.bodySm,
        fontSize: 12,
        color: "#5D6D84",
        lineHeight: 1.55,
        margin: 0,
        ...style,
      }}
    >
      Pagamento gestito da Stripe, provider certificato PCI DSS Level 1.
      <br></br>I dati della carta non transitano sui server Obscura o GRID+.
    </p>
  );
}
